import { Chip } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { memo } from 'react'
import { IoPerson } from 'react-icons/io5'

import { capitalizeSentence as c } from '@/utils'

interface QuestionCardAuthorProps {
  name: string
}

export const QuestionCardAuthor = memo<QuestionCardAuthorProps>(({ name }) => {
  const theme = useTheme()

  return (
    <Chip
      data-qa="question-card-author"
      icon={<IoPerson />}
      label={`Por: ${c(name)}`}
      variant="outlined"
      sx={{
        borderColor: theme.palette.text.secondary,
        color: theme.palette.text.secondary,
        fontWeight: 500,
        borderRadius: 2,
        px: 0.5,
        '& .MuiChip-icon': {
          color: theme.palette.text.secondary,
        },
      }}
    />
  )
})

QuestionCardAuthor.displayName = 'QuestionCardAuthor'
